// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c2c5ad9e","171":"24e252c4"}[chunkId] + ".chunk.js";
};